import * as React from "react";
import { useState, useEffect } from "react";
//import {atom, useSetRecoilState, useRecoilValue} from "recoil";
import $ from "jquery";
import { useFirebaseUser } from "./firebase-auth";

export function Leaderboard({ gameName }) {
  //console.log("TOKEN: " + accessToken);
  const firebaseUser = useFirebaseUser();
  const [didValidate, setDidValidate] = useState(false);
  const [leaderboardInfo, setLeaderboardInfo] = useState(null);
  const [playerRankInfo, setPlayerRankInfo] = useState(null);
  const [authChange, setAuthChange] = useState(false);

  //console.log("UID: " + firebaseUser.uid);

  var title = "Top Players";
  var rewardImg = "";
  var rewardText = "";
  var gameStart = "Coming Soon!";
  //var event = "";
  if (gameName == "tpbgame") {
    title = "Trailer Park Boys";
    rewardImg = "img/BWBasePack.png";
    rewardText = "* Top Prize Wins an Exclusive Nifty Stash NFT";
    gameStart = "Event starts: 2PM PST on Fri 7/2!";
    //event = "Samsquamptch-2021-04-14"; //"MockEvent-By-Benson-Teehee";
  } else if (gameName == "bfweedrev") {
    title = "Bud Farm Idle Tycoon";
    rewardImg = "img/BWBasePack.png";
    rewardText = "* Top Prize Wins an Exclusive Nifty Stash NFT";
    gameStart = "Event starts: 2PM PST on Wed 6/30!";
    //event = "CloneTakeover-2020-06-21";
  } else if (gameName == "bfcc") {
    title = "Cheech & Chong Bud Farm";
    rewardImg = "img/BWBasePack.png";
    rewardText = "* Top Prize Wins an Exclusive Nifty Stash NFT";
    gameStart = "Event starts: 6AM PST on Fri 7/2!";
    //event = "TestEvent-420";
  }

  function getRandomName() {
    const randomNames = [
      "Ricky",
      "Julian",
      "Bubbles",
      "Lahey",
      "Randy",
      "Sarah",
      "Tyrone",
      "Barbara",
      "Cory",
      "J-Roc",
      "Lucy",
      "Trinity",
      "Jacob",
      "George",
      "Trevor",
      "Sam",
      "Cyrus",
      "Ted",
      "Phil",
      "DVS",
      "Treena",
      "Marguerite",
    ];
    var i = Math.floor(Math.random() * randomNames.length);
    return randomNames[i];
  }

  useEffect(() => {
    // Confirm the link is a sign-in with email link.
    if (
      (!didValidate && gameName != null) ||
      (!authChange && firebaseUser.didAuth)
    ) {
      setDidValidate(true);

      if (!authChange && firebaseUser.didAuth) {
        setAuthChange(true);
      }

      var beforeFunc = null;
      var externalAccountId = null;
      if (firebaseUser.didAuth) {
        externalAccountId = firebaseUser.uid;
        beforeFunc = function (xhr) {
          xhr.setRequestHeader(
            "Authorization",
            "Bearer " + firebaseUser.accessToken
          );
        };
      }

      var myRank = -1;
      const buildBoardFunc = function (item) {
        var className = "odd";
        if (parseInt(item.rank, 10) % 2 == 0) {
          className = "even";
        }

        var playerName = item.name;
        if (item.rank != myRank) {
          if (
            playerName == "N/A" ||
            playerName == "" ||
            playerName.length < 1
          ) {
            playerName = getRandomName();
          } else if (playerName.indexOf("(") > -1) {
            var i = playerName.indexOf("(");
            playerName = playerName.substring(0, i);
          }

          if (playerName.charAt(playerName.length - 1) != " ") {
            playerName = playerName + " [" + item.waxwallet + "]";
          } else {
            playerName = playerName + "[" + item.waxwallet + "]";
          }
        } else {
          playerName = "" + firebaseUser.email + " [" + item.waxwallet + "]";
          className = "me";
        }

        return (
          <li key={item.rank.toString()} className={className}>
            <mark>
              {item.rank}&nbsp;&nbsp;&nbsp;{playerName}
            </mark>
            <small>{item.currentCash}</small>
          </li>
        );
      };

      $.ajax(
        "https://wh8qkpt775.execute-api.us-west-2.amazonaws.com/prod/getEventLeaderboard",
        {
          method: "GET",
          dataType: "json",
          beforeSend: beforeFunc,
          data: {
            gameName: gameName,
            //eventId: 'blah',
            externalAccountId: externalAccountId,
            sortType: "Current", //'Projected',
            rankFrom: 1,
            rankTo: 100,
          },
        }
      )
        .done(function (oData) {
          if (oData) {
            const numbersToConvert = oData.eventStartEpoch * 1000;
            const convertedTime = new Date(numbersToConvert);
            let options = {
              weekday: "long",
              year: "numeric",
              month: "long",
              day: "numeric",
              hour: "2-digit",
              minute: "2-digit",
            };
            const gameStartWithCommas = convertedTime.toLocaleTimeString(
              "en-us",
              options
            );
            const gameStart = gameStartWithCommas.replace(/,/g, "");
            if (oData.leaderboard.length == 0) {
              setLeaderboardInfo(
                <li key="None" className="odd">
                  <mark>{`Event Starts: ${gameStart}!`}</mark>
                  <small></small>
                </li>
              );
            } else {
              if (
                oData.playerStat &&
                oData.playerStat.playerRelativeLeaderboard
              ) {
                myRank = oData.playerStat.playerRank;

                // highlight players rank within closest 10 players, or within Top 25
                if (myRank > 25) {
                  const playerRank =
                    oData.playerStat.playerRelativeLeaderboard.map(
                      buildBoardFunc
                    );
                  setPlayerRankInfo(playerRank);
                }
              }

              const listItems = oData.leaderboard
                .slice(0, 25)
                .map(buildBoardFunc);
              setLeaderboardInfo(listItems);
            }
          }
        })
        .fail(function (jqXHR, textStatus) {
          console.log("Leaderboard retrieval failed: " + textStatus);
        });
    }
  });

  return (
    <>
      {gameName && (
        <div class="container">
          <div class="leaderboard">
            <div class="head">
              <h2>{title}</h2>
              <img src={rewardImg} />
              <h3>{rewardText}</h3>
            </div>
            <div class="body">
              <ul>
                {leaderboardInfo}
                <li class="break">...</li>
                {playerRankInfo}
              </ul>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
